import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

import Adminnavbar from "../Adminnavbar";

export default function CreateDownload() {
  const [loader, setLoader] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
  const [download, setDownload] = useState({
    title: "",
    description: "",
    pdf: null,
  });

  const navigate = useNavigate();

  // ================= HANDLE TEXT INPUT =================
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDownload({ ...download, [name]: value });
  };

  // ================= HANDLE PDF FILE =================
  const handleFileChange = (e) => {
    const { files } = e.target;
    const file = files[0];
    setDownload({ ...download, pdf: e.target.files[0] });
    setPdfPreviewUrl(URL.createObjectURL(file));
  };

  // ================= SUBMIT FORM =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    // VALIDATIONS
    if (!download.title.trim() || !download.description.trim()) {
      Swal.fire({
        title: "Please enter all fields",
        icon: "warning",
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("title", download.title);
      formData.append("description", download.description);

      if (download.pdf) {
        formData.append("pdf", download.pdf);
      }

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/download/store`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "PPT & Tool Inserted Successfully",
          timer: 1500,
        }).then(() => navigate("/ppt-tool-list"));
      } else {
        Swal.fire({
          title: "PPT & Tool Insert Failed",
          icon: "error",
        });
      }
    } catch (err) {
      console.error(err);
      setLoader(true);
      Swal.fire({
        title: "Something went wrong!",
        icon: "error",
      });
    }
  };

  return (
    <>
      <Adminnavbar />

      {loader || (
        <div className="page-wrapper">
          <div className="content">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <nav
                  aria-label="breadcrumb"
                  style={{ "--bs-breadcrumb-divider": "none" }}
                >
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashbord">Dashboard </Link> /
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/ppt-tool-list">PPT & Tools Download </Link> /
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Add PPT & Tools
                    </li>
                  </ol>
                </nav>

                <div className="col-lg-12 col-sm-12">
                  <div className="content-page-header">
                    <h5>Add PPT & Tools</h5>
                  </div>

                  <div className="row">
                    {/* Title */}
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label>Title</label>
                        <input
                          type="text"
                          name="title"
                          className="form-control"
                          placeholder="Enter Title"
                          value={download.title}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Description */}
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>Description</label>
                        <textarea
                          name="description"
                          className="form-control"
                          placeholder="Enter Description"
                          rows="4"
                          value={download.description}
                          onChange={handleInputChange}
                          required
                        ></textarea>
                      </div>
                    </div>

                    {/* PDF Upload */}
                    <div className="col-lg-4 mt-3">
                      <div className="form-group">
                        <label>Upload PDF</label>
                        <input
                          type="file"
                          name="pdf"
                          accept="application/pdf"
                          className="form-control"
                          onChange={handleFileChange}
                        />
                      </div>
                    </div>

                    {pdfPreviewUrl && (
                      <div style={{ marginTop: "20px" }}>
                        <embed
                          src={pdfPreviewUrl} // use the stored URL
                          type="application/pdf"
                          width="100%"
                          height="500px"
                        />
                      </div>
                    )}

                    {/* Buttons */}
                    <div className="col-lg-12 mt-4">
                      <div className="btn-path">
                        <Link to={"/ppt-tool-list"} className="btn btn-cancel me-3">
                          Back
                        </Link>
                        <button type="submit" className="btn btn-submit">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
